"use strict";
var alert_component_1 = require('./alert/alert.component');
exports.AlertComponent = alert_component_1.AlertComponent;
var alert_module_1 = require('./alert/alert.module');
exports.AlertModule = alert_module_1.AlertModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/components/alert.js
// module id = 995
// module chunks = 1